<template>
  <div class='post-list'>
    <div v-for="post in posts" :key="post.id">
      <!-- <h3>{{ post.title }}</h3> -->
      <Singlepost :post="post" />
    </div>  
  </div>
</template>

<script>
import Singlepost from '../components/Singlepost'
export default {
  props: ['posts'],
  components: {
    Singlepost
  }
}
</script>